import React from 'react';
import PropTypes from 'prop-types';
import utils from '../../util';

const DomainSearchResult = ({
  styles,
  mediaOutlet,
  domain,
  sourceProviders,
  isValid,
  authorGroupNames,
  isCovered,
  storyCount,
  hasGroups,
  lastCoveredAt,
}) => (
  <div className={styles.sourceCheckerSearchResult}>
    <div
      className={`${styles.sourceCheckerSearchResultIcon}
      ${styles[utils.getClassNameBasedOnCoverage(isValid, isCovered)]}`}
    >
      {utils.getIconBasedOnCoverage(isValid, isCovered)}
    </div>
    {!isValid && (
      <div>
        <div>
          {domain}
        </div>
        <div>
          <b>Note: </b> Domain or url not valid
        </div>
      </div>
    )}
    {isValid && (
      <div>
        {domain}
        <ul className={styles.sourceCheckerSearchResultList}>
          <li><b>Source provided by: </b>{utils.getCommaSeparatedStringOrNone(sourceProviders)}</li>
          <li><b>Media outlet: </b>{mediaOutlet || 'None'}</li>
          {
            isCovered && hasGroups
            && <li><b>Matching Groups: </b> {utils.getCommaSeparatedStringOrNone(authorGroupNames)}</li>
          }
        </ul>
        <div
          className={styles.searchResultStats}
          dangerouslySetInnerHTML={{ __html: utils.getPrettyfiedStatistics(storyCount, lastCoveredAt) }}
        />
      </div>
    )}
  </div>
);

DomainSearchResult.propTypes = {
  styles: PropTypes.object,
  mediaOutlet: PropTypes.string,
  domain: PropTypes.string,
  sourceProviders: PropTypes.arrayOf(PropTypes.string),
  isValid: PropTypes.bool,
  isCovered: PropTypes.bool,
  authorGroupNames: PropTypes.arrayOf(PropTypes.string),
  storyCount: PropTypes.number,
  hasGroups: PropTypes.bool,
  lastCoveredAt: PropTypes.string,
};

export default DomainSearchResult;
